export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=2400&q=90";

export const INTERIOR_IMAGES = {
  living: "https://images.unsplash.com/photo-1617228133035-2347f159e755?auto=format&fit=crop&w=2000&q=90",
  kitchen: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?auto=format&fit=crop&w=2000&q=90",
  bathroom: "https://images.unsplash.com/photo-1564540579594-0930edb6de43?auto=format&fit=crop&w=2000&q=90",
  exterior: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=2000&q=90",
};

export const SERVICES = [
  {
    id: "ristrutturazioni",
    icon: "Hammer",
    title: "Ristrutturazioni Chiavi in Mano",
    desc: "Dal rilievo iniziale alla consegna finale: un unico interlocutore per trasformare il tuo immobile senza stress.",
    features: [
      "Demolizioni e ricostruzioni interne",
      "Rifacimento impianti a norma",
      "Finiture e materiali di pregio",
      "Direzione lavori inclusa",
    ],
  },
  {
    id: "nuove-costruzioni",
    icon: "Building2",
    title: "Nuove Costruzioni",
    desc: "Edifici residenziali e commerciali costruiti secondo i più alti standard antisismici ed energetici.",
    features: [
      "Strutture in cemento armato e acciaio",
      "Edilizia residenziale e commerciale",
      "Standard antisismici aggiornati",
      "Obiettivo classe energetica A",
    ],
  },
  {
    id: "cappotti",
    icon: "Leaf",
    title: "Cappotti Termici & Efficienza",
    desc: "Riqualificazione energetica completa: meno consumi, più comfort, valore crescente nel tempo.",
    features: [
      "Isolamento a cappotto minerale",
      "Integrazione fotovoltaico",
      "Gestione pratiche e bonus fiscali",
      "Certificazione energetica APE",
    ],
  },
  {
    id: "restauri",
    icon: "Landmark",
    title: "Restauri & Consolidamenti",
    desc: "Recupero conservativo di edifici storici con tecniche tradizionali e tecnologie d'avanguardia.",
    features: [
      "Restauro conservativo certificato",
      "Consolidamento strutturale",
      "Recupero facciate e stucchi",
      "Materiali tradizionali e biocompatibili",
    ],
  },
];

export const PROJECTS = [
  {
    id: "proj-01",
    title: "Villa Modernista all'Olgiata",
    group: "Esterni",
    category: "Ristrutturazione Completa",
    location: "Roma",
    year: "2025",
    surface: "450 m²",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=2000&q=90",
    description:
      "Riqualificazione energetica in Classe A4, ampliamento volumetrico, piscina infinity integrata e facciate ventilate.",
  },
  {
    id: "proj-02",
    title: "Penthouse Open Space Sempione",
    group: "Interni",
    category: "Interni di Pregio",
    location: "Milano",
    year: "2025",
    surface: "280 m²",
    image:
      "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?auto=format&fit=crop&w=2000&q=90",
    description:
      "Ristrutturazione totale degli interni con arredi su misura, camino minimalista integrato e travi in legno sbiancato.",
  },
  {
    id: "proj-03",
    title: "Cucina con Isola a Posillipo",
    group: "Cucine",
    category: "Cucine & Living",
    location: "Napoli",
    year: "2024",
    surface: "310 m²",
    image:
      "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&w=2000&q=90",
    description:
      "Isola centrale in quarzo e marmo, illuminazione architetturale a sospensione e domotica avanzata.",
  },
  {
    id: "proj-04",
    title: "Rustico Moderno nel Chianti",
    group: "Restauro",
    category: "Restauro Conservativo",
    location: "Firenze",
    year: "2024",
    surface: "520 m²",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=2000&q=90",
    description:
      "Unione tra pietra tradizionale toscana recuperata ed elementi contemporanei in acciaio e vetro.",
  },
  {
    id: "proj-05",
    title: "Bagno Spa a Porta Nuova",
    group: "Bagni",
    category: "Bagni di Design",
    location: "Milano",
    year: "2025",
    surface: "45 m²",
    image:
      "https://images.unsplash.com/photo-1576698483491-8c43f0862543?auto=format&fit=crop&w=2000&q=90",
    description:
      "Rivestimento completo in marmo, lavabi sospesi in ceramica sartoriale e doccia emozionale a filo pavimento.",
  },
  {
    id: "proj-06",
    title: "Loft Architetturale ai Navigli",
    group: "Interni",
    category: "Conversione & Loft",
    location: "Milano",
    year: "2024",
    surface: "220 m²",
    image:
      "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=2000&q=90",
    description:
      "Conversione di ex spazio industriale in loft residenziale con scala scenografica in legno e struttura in acciaio.",
  },
  {
    id: "proj-07",
    title: "Villa Panorama in Costa Smeralda",
    group: "Esterni",
    category: "Esterni & Solarium",
    location: "Porto Cervo",
    year: "2025",
    surface: "600 m²",
    image:
      "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?auto=format&fit=crop&w=2000&q=90",
    description:
      "Ampliamento delle terrazze panoramiche, serramenti a totale scomparsa e solarium in pietra naturale.",
  },
  {
    id: "proj-08",
    title: "Salone Open Living ad Albaro",
    group: "Interni",
    category: "Interni Residenziali",
    location: "Genova",
    year: "2024",
    surface: "190 m²",
    image:
      "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?auto=format&fit=crop&w=2000&q=90",
    description:
      "Luce naturale protagonista, pavimentazione in parquet di rovere e vetrate a tutt'altezza sul giardino.",
  },
];

export const PROJECT_CATEGORIES = ["Tutti", "Esterni", "Interni", "Cucine", "Bagni", "Restauro"];

export const BEFORE_AFTER = {
  before: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=85",
  after: "https://images.unsplash.com/photo-1633330977020-2bdfb8530cc2?auto=format&fit=crop&w=2000&q=90",
  beforeLabel: "Prima · struttura originaria",
  afterLabel: "Dopo · ristrutturato TecnoEdil",
};

export const CONTACT_INFO = {
  address: "Via Oreste Salomone 85, Milano (MI)",
  phone: "+39 331 488 6685",
  email: "tecnoedil.ea@gmail.com",
  hours: "Lun – Ven · 8:00 – 18:00",
  piva: "P.IVA 14438150964",
};
